import { getRequestHeaders } from 'h3'

export default defineNuxtRouteMiddleware((to, _from) => {
  if (!process.server) return
  const event = useRequestEvent()
  const headers = event ? getRequestHeaders(event) : undefined
  const hostName = headers?.host?.split(':')[0]
  const hostPort = headers?.host?.split(':')[1] ?? 443
  const { startRequestSpan } = useOpenTelemetryStore()
  const url = to.path

  startRequestSpan({
    url,
    attributes: {
      'http.user_agent': headers ? headers['user-agent'] : undefined,
      'net.host.name': hostName,
      'net.host.port': hostPort,
    },
  })
})
